// Commission-amount math shared by the claim-entry surfaces. The claim preview
// (single-entry ClaimEntryPage and the Bulk Entry grid) both derive the same
// dollar figure from a gross revenue and a commission percent; keep it here so
// the two can't drift.

/**
 * The commission dollar amount for a gross revenue at a commission percent,
 * rounded to cents. `pct` is a percent (10 for 10%), not a fraction. Mirrors the
 * `Math.round((gross * pct) / 100 * 100) / 100` both entry surfaces used inline.
 */
export function commissionAmount(gross: number, pct: number): number {
  return Math.round(((gross * pct) / 100) * 100) / 100;
}
